import React, { useState } from 'react';
import { FiAlertCircle, FiEye, FiEyeOff } from 'react-icons/fi';

// SimpleFormField - doesn't require react-hook-form
interface SimpleFormFieldProps {
  label: string;
  name: string;
  type?: string;
  placeholder?: string;
  required?: boolean;
  icon?: React.ReactNode;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  error?: string;
  className?: string;
  showPasswordToggle?: boolean; // For password fields
  maxLength?: number;
}

export const SimpleFormField: React.FC<SimpleFormFieldProps> = ({
  label,
  name,
  type = 'text',
  placeholder,
  required = false,
  icon,
  value,
  onChange,
  onFocus,
  error,
  className = '',
  showPasswordToggle = false,
  maxLength,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPasswordField = type === 'password';
  const inputType = isPasswordField && showPasswordToggle && showPassword ? 'text' : type;

  return (
    <div className={className}>
      <label htmlFor={name} className="block text-sm font-medium text-foreground/90 mb-2">
        {label}
        {required && <span className="text-red-400 ml-1">*</span>}
      </label>
      <div className="relative">
        {icon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            {icon}
          </div>
        )}
        <input
          id={name}
          name={name}
          type={inputType}
          placeholder={placeholder}
          required={required}
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          maxLength={maxLength}
          className={`input-field ${icon ? 'pl-10' : ''} ${showPasswordToggle && isPasswordField ? 'pr-10' : ''} ${error ? 'border-red-500' : ''}`}
        />
        {showPasswordToggle && isPasswordField && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute inset-y-0 right-0 pr-3 flex items-center text-white/40 hover:text-white/70 transition-colors"
            tabIndex={-1}
          >
            {showPassword ? (
              <FiEyeOff className="h-5 w-5" />
            ) : (
              <FiEye className="h-5 w-5" />
            )}
          </button>
        )}
      </div>
      {error && (
        <div className="mt-1 flex items-center gap-1 text-red-600 text-sm">
          <FiAlertCircle className="h-4 w-4 flex-shrink-0" />
          <span className="min-w-0 break-words">{error}</span>
        </div>
      )}
    </div>
  );
};

